import { createResource, type RouteResource } from '@atlassian/react-resource-router';

const RESOURCE_TYPE_PRODUCT_JSW_CONFIGURATION = 'RESOURCE_TYPE_PRODUCT_JSW_CONFIGURATION';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const productsJswConfigurationResource: RouteResource<any> = createResource<any>({
	type: RESOURCE_TYPE_PRODUCT_JSW_CONFIGURATION,
	getKey: () => 'state',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-products-jsw-configuration", jiraSpaEntry: "async-resource-products-jsw-configuration" */ './getData.tsx'
		),
});
